var map = {
	"./airasia.svg": "0557",
	"./citilink.svg": "9e97",
	"./citilinkCorporate.svg": "c361",
	"./garuda.svg": "3202",
	"./lion.svg": "ebda",
	"./sriwijaya.svg": "dbeb",
	"./transnusa.svg": "e1ad",
	"./trigana.svg": "f7f1",
	"./xpress.svg": "8ac4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d82c";